<template>
  <!-- <h1 class="fs-3 m-0 ps-5 py-2">{{ this.title }}</h1> -->
  <div class="hello helloCountryMap mt-1 w-100 bg-white" id="chartdivMap">
  </div>
</template>

<script>
import * as am4core from "@amcharts/amcharts4/core";
import * as am4maps from "@amcharts/amcharts4/maps";
import am4geodata_worldLow from "@amcharts/amcharts4-geodata/worldLow";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
/* eslint-disable */
import { countryToAlpha3 } from "country-to-iso";
import globalVar from "@/assets/globalVar.json"

export default {
  data() {
    return {
      selectedCountry: { id: '', value: 0 },
    }
  },
  props: {
    map: {
      type: Object,
      required: true,
    },
    country: {
      type: Array,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      required: true,
    }
  },
  methods: {
    getColor(value) {
      let rangesData = globalVar.risk
      let category = '';
      if (value >= 5) {
        category = rangesData[4].color;
      } else {
        category = '#808080'
        for (let i = 0; i < rangesData.length; i++) {
          if (value >= rangesData[i].rangeMin - 0.005 && value <= rangesData[i].rangeMax - 0.005) {
            category = rangesData[i].color;
            break;
          }
        }
      }
      return category;
    },
    modifyCountryToAlpha3(countryIdOrName) {
      const originalCountryToAlpha3 = countryToAlpha3;
      if ((countryIdOrName === 'KSV') | (countryIdOrName === 'Kosovo') | (countryIdOrName === 'XK')) {
        return 'KSV';
      } else {
        return originalCountryToAlpha3(countryIdOrName);
      }
    },
    GetCountry() {
      this.countryIn = this.modifyCountryToAlpha3(this.$route.params.element);
      if (this.map.hasOwnProperty(this.countryIn)) {
        this.selectedCountry.id = this.map[this.countryIn].name;
        this.selectedCountry.value = this.map[this.countryIn].risk;
      }
    },
    renderChart() {
      am4core.useTheme(am4themes_animated);
      let chart = am4core.create("chartdivMap", am4maps.MapChart);

      chart.geodata = am4geodata_worldLow;

      chart.projection = new am4maps.projections.Miller();
      chart.homeGeoPoint = {
        latitude: 30, // Keep it centered vertically
        longitude: 50 // Shift to the left horizontally, adjust this value as needed
      };
      let polygonSeries = chart.series.push(new am4maps.MapPolygonSeries());

      polygonSeries.useGeodata = true;
      const mapData = Object.values(this.map).map(item => ({
        id: item.country_id,
        value: item.value,
        value_str: item.value > 0 ? (Math.round(item.value * 100) / 100).toFixed(2) : '',
        fill: am4core.color(this.getColor(item.value)),
      }));
      polygonSeries.data = mapData;
      chart.deltaLongitude = -10;
      var legend = new am4maps.Legend();
      let rangesData = globalVar.risk
      legend.parent = chart.chartContainer;
      legend.background.fill = am4core.color("#000");
      legend.background.fillOpacity = 0.05;
      legend.width = 275;
      legend.align = "right";
      legend.padding(10, 15, chart.chartContainer.maxHeight, 15);
      legend.data = [{
        "name": `${rangesData[0].indicator} (${rangesData[0].rangeMin.toFixed(2)} to ${(rangesData[0].rangeMax - 0.01).toFixed(2)})`,
        "fill": rangesData[0].color
      }, {
        "name": `${rangesData[1].indicator} (${rangesData[1].rangeMin.toFixed(2)} to ${(rangesData[1].rangeMax - 0.01).toFixed(2)})`,
        "fill": rangesData[1].color
      }, {
        "name": `${rangesData[2].indicator} (${rangesData[2].rangeMin.toFixed(2)} to ${(rangesData[2].rangeMax - 0.01).toFixed(2)})`,
        "fill": rangesData[2].color
      }, {
        "name": `${rangesData[3].indicator} (${rangesData[3].rangeMin.toFixed(2)} to ${(rangesData[3].rangeMax - 0.01).toFixed(2)})`,
        "fill": rangesData[3].color
      }, {
        "name": `${rangesData[4].indicator} (${rangesData[4].rangeMin.toFixed(2)} to ${(rangesData[4].rangeMax).toFixed(2)})`,
        "fill": rangesData[4].color
      },
      {
        "name": "no/partial assessment \ndue to lack of data",
        "fill": "#808080"
      }];
      legend.itemContainers.template.clickable = false;
      legend.itemContainers.template.focusable = false;

      var legendTitle = legend.createChild(am4core.Label);
      legendTitle.text = "Risk level :";

      let polygonTemplate = polygonSeries.mapPolygons.template;
      polygonTemplate.applyOnClones = true;
      polygonTemplate.togglable = true;
      polygonTemplate.tooltipText = "{name} : {value_str}";
      polygonTemplate.nonScalingStroke = true;
      polygonTemplate.strokeOpacity = 0.5;
      polygonTemplate.fill = 'rgb(128, 128, 128)';
      // polygonTemplate.cursorOverStyle = am4core.MouseCursorStyle.pointer;
      // polygonTemplate.events.on("hit", this.handleHit);
      polygonTemplate.propertyFields.fill = "fill";

      polygonSeries.exclude = ["AQ"];
      chart.exporting.menu = new am4core.ExportMenu();
      chart.exporting.filePrefix = 'my_own_score'
      chart.exporting.menu.align = "left";
      chart.exporting.menu.verticalAlign = "top";

      chart.exporting.menu.items = [
        {
          label: '<i class="fas fa-download"></i>',  // Using a download icon from FontAwesome
          menu: [
            { type: "png", label: "PNG" }
          ]
        }
      ];

    }
  },
  mounted() {
    this.GetCountry()
    this.renderChart()
  },
  watch: {
    map: {
      handler(newValue, oldValue) {
        this.renderChart()
      },
      deep: true
    }
  }
}

</script>
